import React from 'react';

const TextRight = ({ color, onClick }) => {
  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width='22.404'
      height='17.228'
      viewBox='0 0 22.404 17.228'
      onClick={onClick}
      cursor='pointer'
    >
      <g id='Group_78882' data-name='Group 78882' transform='translate(1 1)'>
        <line
          id='Line_266'
          data-name='Line 266'
          x2='20.17'
          transform='translate(0)'
          fill='none'
          stroke={color}
          stroke-linecap='round'
          stroke-width='2'
        />
        <line
          id='Line_270'
          data-name='Line 270'
          x2='13.636'
          transform='translate(6.768 5.076)'
          fill='none'
          stroke={color}
          stroke-linecap='round'
          stroke-width='2'
        />
        <line
          id='Line_271'
          data-name='Line 271'
          x2='20.17'
          transform='translate(0 10.152)'
          fill='none'
          stroke={color}
          stroke-linecap='round'
          stroke-width='2'
        />
        <line
          id='Line_272'
          data-name='Line 272'
          x2='13.636'
          transform='translate(6.768 15.228)'
          fill='none'
          stroke={color}
          stroke-linecap='round'
          stroke-width='2'
        />
      </g>
    </svg>
  );
};

export default TextRight;
